module.exports = __webpack_public_path__ + "89f1fc55b1b9646a667b7cf1a960bdd9.fbx";